// extracted by mini-css-extract-plugin
export default {"flex":"styles_flex__j+q2a","platforms":"styles_platforms__XQRIN"};